import { formatISO, isFuture, parseISO } from 'date-fns'
import { boolean, number, object, string } from 'yup'

const AccessFlexSchema = object().shape({
  contract_ref: string()
    .required('Please enter your agreement number')
    .matches(
      /^[0-9]{12}$/,
      'Please enter a valid agreement number, e.g. 000030103010',
    )
    .max(12, 'Agreement number must be at most 12 characters')
    .trim(),
  reg_num: string()
    .required('Please enter your registration')
    .matches(
      /^[a-zA-Z0-9]{1,4}\s?[a-zA-Z0-9]{1,3}$/,
      'Please enter a valid registration',
    )
    .trim(),
  last_name: string()
    .required('Surname is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,30}$/,
      'Surname can only contain letters and basic punctuation',
    )
    .min(2, 'Surname must be at least 2 characters')
    .max(30, 'Surname must be at most 30 characters')
    .trim(),
  dob: string()
    .required('Please enter your date of birth')
    .transform((value) => {
      if (value) {
        const parts = value.split('/')
        const formattedDate = new Date(parts[2], parts[1] - 1, parts[0])
        return formatISO(formattedDate, { representation: 'date' })
      }
      return value
    })
    .test(
      'is-future',
      'Date of birth cannot be in the future',
      (value) => !isFuture(parseISO(value)),
    ),
  postcode: string()
    .required('Please enter your post code')
    .matches(
      /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/,
      'Please enter a valid post code',
    )
    .max(25)
    .trim(),
})

const AccessFlexSchema2 = object().shape({
  months: number().required('Please select a payment break length'),
  terms: boolean().oneOf(
    [true],
    'Please confirm you have read and understood the terms',
  ),
})

export { AccessFlexSchema, AccessFlexSchema2 }
